import React from 'react';
import axios from "axios";
import { Container, Grid, useMantineTheme, Box, Group, Flex, Input, ActionIcon, Text, Center } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { IconSearch, IconReload, IconBarcode } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_THREE, utils } from "../../utils/globalVariables";

import AmountOfData from "../../components/general/AmountOfData";
import ActionIconComponent from "../../components/general/ActionIconComponent";

import NoData from "../../components/general/NoData";
import WrapperUtils from "../../layout/WrapperUtils";

import SerialNumberCheckerCard from "./SerialNumberCheckerCard";
import ScannerBarQRCodeModul from "./ScannerBarQRCodeModul";

const SerialNumberCheckerIndex = () => {

  const mountedRef = React.useRef(true);

  const theme = useMantineTheme();
  // const matchesMaxXS = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const matchesMinMD = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'SerialNumberCheckerIndex-1',
  })

  const [data, setData] = React.useState({
    data: [],
    dataCount: 0,
    dataFlag: 'idle',
    dataLoading: false,
    dataRefresh: new Date(),
    dataOffset: 0,

    snText: '',
    snTextRef: '',

    res: '',
    scannerModal: false,

    viewData: {
      drawer: false,
      data: []
    },
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const AmountOfDataComponent = () => {
    return (
      <AmountOfData
        stateDataLimit={utils.dataLimit}
        stateDataOffset={data.dataOffset}
        stateAmountDataAll={data.dataCount}
        stateDataFlag={data.dataFlag}
        stateSuffix=''

        fnFirstData={(stateNewOffset) => setData(d => ({
          ...d,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}

        fnLastData={(stateNewOffset) => setData(d => ({
          ...d,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}

        fnPreviousData={(stateNewOffset) => setData(d => ({
          ...d,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}

        fnNextData={(stateNewOffset) => setData(d => ({
          ...d,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}
      />
    )
  }

  React.useEffect(() => {
    if (data.snText) {
      setData(d => ({ ...d, dataLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('data_limit', utils.dataLimit);
      formDT.append('data_offset', data.dataOffset);

      formDT.append('flag_all', utils.flagAll);
      formDT.append('filter_sn', data.snText);
      // formDT.append('filter_supplier_is_active', data.xxx);

      axios({
        method: 'post',
        url: BE_API_THREE + '/get_item_by_serial_number',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataCount: response.data.data_count,
            dataFlag: response.data.data.length > 0 ? true : false,
          }));
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataLoading: false,
        }));

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext.syswebapp, data.dataRefresh, data.snText, data.dataOffset])

  return (
    <React.Fragment>
      <WrapperUtils
        stateDataLoading={data.dataLoading}
      >
        <Group spacing='xs' noWrap>
          <ActionIconComponent
            stateVariant='light'
            stateRadius='xl'
            stateTitle='Reload Data'
            stateSize='lg'
            fnOnClick={() => setData(d => ({ ...d, dataRefresh: new Date() }))}

            StateIcon={IconReload}
            stateIconSize='1.125rem'
            stateIconStrokeWidth={1.25}
            stateIconStyle={{
              color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
            }}
          />

          <Input
            placeholder="Serial Number"
            radius='sm'
            size='sm'
            icon={
              <ActionIcon
                onClick={() => setData(d => ({ ...d, scannerModal: true }))}
                color='blue'
                variant='light'
                sx={{ pointerEvents: 'auto' }}
              >
                <IconBarcode size="1.5rem" style={{ display: 'block', opacity: 1 }} />
              </ActionIcon>
            }

            rightSection={
              <ActionIcon
                onClick={
                  data.snTextRef ?
                    () => setData(d => ({ ...d, snText: d.snTextRef, dataRefresh: new Date() }))
                    :
                    () => { }
                }
                color='blue'
                variant='filled'
              >
                <IconSearch size="1rem" style={{ display: 'block', opacity: 1 }} />
              </ActionIcon>
            }

            value={data.snTextRef}
            onChange={(e) => setData(d => ({ ...d, snTextRef: e.target.value }))}

            onKeyUp={data.snTextRef ?
              (e) => (e.key === 'Enter') && setData(d => ({ ...d, snText: d.snTextRef, dataRefresh: new Date() }))
              :
              () => { }
            }
          />
        </Group>

        {matchesMinMD &&
          <Flex
            sx={{ flex: 1 }}
            justify="flex-end"
            align="center"
            direction="row"
            wrap="nowrap"
          >
            <AmountOfDataComponent />
          </Flex>
        }
      </WrapperUtils>

      <Container fluid>
        <Grid my={0}>
          {Array.isArray(data.data) && (data.data.length <= 0) && data.dataFlag !== 'idle' &&
            <Grid.Col span={12}>
              <NoData />
            </Grid.Col>
          }

          {Array.isArray(data.data) && (data.data.length <= 0) && data.dataFlag === 'idle' &&
            <Grid.Col span={12}>
              <Center mt='2rem'>
                <Text
                  color='dimmed'
                  size='sm'
                >
                  Scan atau ketik serial number yang akan dicari pada kolom pencarian diatas.
                </Text>
              </Center>
            </Grid.Col>
          }

          {Array.isArray(data.data) && (data.data.length > 0) &&
            <Grid.Col
              span={12}
              py={0}
            >
              <Box mt='md'>
                <SerialNumberCheckerCard
                  stateData={data.data}

                  fnSelectedDataView={(val) => setData(d => ({
                    ...d,
                    viewData: {
                      ...d.viewData,
                      data: val,
                      drawer: true
                    }
                  }))}
                />
              </Box>
            </Grid.Col>
          }
        </Grid>
      </Container>

      <ScannerBarQRCodeModul
        stateData={{
          show: data.scannerModal,
        }}

        fnSuccess={(val) => {
          setData(d => ({
            ...d,
            res: val,
            snTextRef: val,
            snText: val,
            scannerModal: false
          }))
        }}

        fnClose={(val) => setData(d => ({ ...d, scannerModal: val }))}

        fnFailed={(val) => { }}
      />
    </React.Fragment>
  )
}

export default SerialNumberCheckerIndex;